exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-120cdb97&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ProductsList.vue
// module id = 348
// module chunks = 0